<div class="rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
  <div class="flex flex-col gap-3 border-b border-gray-100 px-5 py-4 sm:flex-row sm:items-start sm:justify-between sm:px-6 sm:py-5 dark:border-gray-800">
    <div class="space-y-1">
      <h3 class="text-base font-semibold text-gray-900 dark:text-white">Rules and Conduct</h3>
      @if (isSubmitted) {
        <p class="text-sm text-gray-600 dark:text-gray-400">
          Agreement submitted on
          <span class="font-medium text-gray-900 dark:text-white">
            {{ submissionDate | date: 'dd/MM/yyyy HH:mm' }}
          </span>
          @if (event.rules_conduct_submitted_by) {
            by
            <span class="font-medium text-gray-900 dark:text-white">
              {{ event.rules_conduct_submitted_by }}
            </span>
          }
        </p>
      } @else {
        <p class="text-sm text-gray-600 dark:text-gray-400">
          Not yet submitted. All items must be acknowledged before submission.
        </p>
      }
    </div>
    <div class="flex flex-wrap items-center gap-2">
      @if (isSubmitted) {
        <span class="inline-flex items-center gap-1.5 rounded-full bg-success-50 px-3 py-1 text-xs font-medium text-success-700 dark:bg-success-500/10 dark:text-success-400">
          <lucide-icon [img]="CircleCheckIcon" class="h-4 w-4"></lucide-icon>
          Submitted
        </span>
      } @else {
        <span class="inline-flex items-center gap-1.5 rounded-full bg-warning-50 px-3 py-1 text-xs font-medium text-warning-700 dark:bg-warning-500/10 dark:text-warning-400">
          <lucide-icon [img]="CircleDashedIcon" class="h-4 w-4"></lucide-icon>
          Not submitted
        </span>
      }

      @if (isAdmin && isSubmitted) {
        <app-button
          (click)="reset()"
          [label]="'Reset submission'"
          [style]="'danger'"
          [icon]="ResetIcon"
          [disabled]="resetting">
        </app-button>
      }
    </div>
  </div>

  <div class="space-y-6 p-5 sm:p-6">
    <div class="rounded-xl border border-gray-200 bg-gray-50 p-4 text-sm leading-relaxed text-gray-700 dark:border-gray-800 dark:bg-white/[0.03] dark:text-gray-300">
      Please be aware that as the hirer of the venue you are responsible for the conduct and
      behaviour of your guests and suppliers. Our team will work with you and your wedding party as
      best as possible to ensure that everything runs smoothly, but you are liable for any
      infringements or damage caused. For further details and guidance, please refer to our Terms
      and Conditions and Frequently Asked Questions which are available on the website.
    </div>

    <ol class="space-y-3">
      @for (item of checklist; track $index; let index = $index) {
        <li class="rounded-xl border border-gray-200 p-4 transition-colors dark:border-gray-800"
          [ngClass]="{
            'bg-success-50/50 border-success-200 dark:bg-success-500/5 dark:border-success-500/40': acknowledgements.at(index).value,
            'bg-white dark:bg-transparent': !acknowledgements.at(index).value
          }">
          <label class="flex cursor-pointer items-start gap-3">
            <input
              type="checkbox"
              class="mt-0.5 h-5 w-5 shrink-0 cursor-pointer rounded border-gray-300 text-brand-600 focus:ring-brand-500 disabled:cursor-not-allowed dark:border-gray-700 dark:bg-gray-900"
              [formControl]="acknowledgements.at(index)">
            <div class="flex-1 text-sm leading-relaxed text-gray-700 dark:text-gray-300">
              <span class="mr-2 font-semibold text-gray-900 dark:text-white">
                {{ index + 1 }}. {{ item.label }}:
              </span>
              <span>{{ item.body }}</span>
            </div>
          </label>
        </li>
      }
    </ol>

    @if (!submissionLocked) {
    <div class="flex flex-col items-start gap-3 border-t border-gray-100 pt-5 sm:flex-row sm:items-center sm:justify-between dark:border-gray-800">
      @if (isAdmin || isSubmitted) {
        <p class="text-sm text-gray-600 dark:text-gray-400">
          Please click Submit to confirm you have read and agree with the Rules and Conduct.
        </p>
        <app-button
          (click)="submit()"
          [label]="isSubmitted ? 'Submitted' : 'Submit'"
          [style]="'primary'"
          [disabled]="!canSubmit">
        </app-button>
      } @else {
        <p class="text-sm text-gray-600 dark:text-gray-400">
          Only administrators can submit the Rules and Conduct form on behalf of the customer.
        </p>
      }
    </div>
    }
  </div>
</div>
